// Çalışan Raporları tablosunun sütunları (eski tablonun 6 sütunu; tarife
// yalnızca yöneticilere görünür). Metinler: employeeReports.columns.<key>.

export const REPORT_COLUMNS = {
  name: { type: 'text', width: 230 },
  center: { type: 'select', width: 230 },
  project: { type: 'select', width: 180 },
  role: { type: 'select', width: 190 },
  rate: { type: 'text', width: 170 },
  assignedAt: { type: 'date', width: 160 },
};

export const MIN_COLUMN_WIDTH = 96;
export const PINNED_COLUMNS = ['name'];

/** Column keys a user may see (the tariff is for admins only, as before). */
export const columnKeysFor = (isAdmin) => Object.keys(REPORT_COLUMNS).filter((key) => key !== 'rate' || isAdmin);

/** Timestamp / Date / ISO text → Date (or null). */
export const toDate = (value) => {
  if (!value) return null;
  if (typeof value.toDate === 'function') return value.toDate();
  if (value instanceof Date) return value;
  if (value.seconds) return new Date(value.seconds * 1000);
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

/** 'YYYY-MM-DD' of a date (local), for the date filter. */
export const isoDay = (date) => (date ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}` : '');

export const getFilterState = (key, value) => (value === undefined || value === null || String(value) === '' ? 'off' : 'applied');
